import { forwardRef } from "react";

import { sendTelemetryEvent } from "@/lib/telemetry";
import type { TelemetryProps } from "@Components/Modules/Helpers";
import { requestTrack } from "@Components/Modules/Helpers";

import type { IButtonV2 } from "../ButtonV2";
import ButtonV2 from "../ButtonV2";

export interface ITelemetryButton extends IButtonV2, TelemetryProps {}

const TelemetryButton = forwardRef<HTMLButtonElement, ITelemetryButton>(
    ({ telemetryUrl, onClick, telemetryCustom, ...all }, ref) => {
        const clickTelemetry = (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            if (telemetryCustom) {
                sendTelemetryEvent(telemetryCustom);
            } else {
                requestTrack(telemetryUrl);
            }

            if (onClick) {
                onClick(ev);
            }
        };

        return <ButtonV2 {...all} onClick={clickTelemetry} ref={ref} />;
    },
);

export default TelemetryButton;
